import "core-js/modules/es.object.assign.js";

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from 'react';
import Svg, { Path } from 'react-native-svg';

function FlightFill(props) {
  return React.createElement(Svg, _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24"
  }, props), React.createElement(Path, {
    fillRule: "evenodd",
    d: "M19.523 2.18c.689-.234 1.493-.317 2.054.243.56.561.477 1.37.244 2.062-.244.723-.717 1.536-1.264 2.331-1.008 1.465-2.341 2.984-3.218 3.972l4.586 8.754a.5.5 0 01-.09.586l-1.725 1.726a.5.5 0 01-.696.01l-7.001-6.589-3.426 3.045-.825 3.301a.5.5 0 01-.485.379H5.95a.5.5 0 01-.474-.342l-.784-2.351-2.351-.784A.5.5 0 012 18.05v-1.726a.5.5 0 01.374-.484l3.185-.826 3.16-3.432-6.583-6.995a.5.5 0 01.01-.696l1.726-1.725a.5.5 0 01.586-.09l8.758 4.588.23-.198c1.001-.867 2.41-2.087 3.761-3.02.791-.548 1.598-1.022 2.316-1.266z",
    clipRule: "evenodd"
  }));
}

export default FlightFill;